import {Component} from "@angular/core";
import {Field} from "../models/field.model";


@Component({
	selector: "tig-form-checkbox",
	template: `
    <div
		class="form-group"
		[formGroup]="OBJ_form_group"
		[ngClass]="{'has-error': isInvalid()}">
		<ng-template #tooltipTemplate><div [innerHtml]="getHint()|translate"></div></ng-template>
		<label class="col-lg-2 control-label" [ngClass]="{'tgi-new': isNew()}">{{getLabelName()|translate}}
			<i *ngIf="getHint()" class="fa fa-info-circle tig-tooltip-icon"
				[tooltip]="tooltipTemplate"
				placement="top"
				triggers="click"
				containerClass="tig-tooltip"
				delay="50"></i>
            <span *ngIf="isRequired()" class="tgi-asterisk"> *</span></label>
		<div class="col-lg-8">
			<div tigCheck>
				<input
				(click)="setValue($event)"
				[placeholder]="getLabelName()|translate"
				[formControlName]="OBJ_field_config.name"
				type="checkbox"
				/>
            </div>
			<div class="tig-hint" *ngIf="OBJ_field_config.note">
				<span>{{ OBJ_field_config.note|translate}}</span>
			</div>
            <tig-form-error [OBJ_form_control]="getFormControl()"></tig-form-error>
		</div>
    </div>
  `
})
export class FormCheckboxComponent extends Field {

	setValue(event: any) {
		super.setValue(event.target.checked);
	}

} // end class FormCheckboxComponent
